import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import BrandSection from './components/BrandSection';
import FeaturedProducts from './components/FeaturedProducts';
import FeaturesSection from './components/FeaturesSection';
import ReviewsSection from './components/ReviewsSection';
import CtaSection from './components/CtaSection';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const HOME_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Koorpet',
    url: siteUrl,
    description: '专注猫抓板研发生产，提供瓦楞纸猫抓板、剑麻猫抓柱、猫爬架等优质宠物用品',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/products?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Koorpet',
    url: siteUrl,
    logo: `${siteUrl}/favicon.png`,
    description: '专注猫抓板研发生产，天然环保材料，10万+猫咪信赖之选',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: 'cs@koorpet.com',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Koorpet - 专注猫抓板匠心品牌 | 天然环保宠物用品"
        description="Koorpet - 专注猫抓板研发生产，提供瓦楞纸猫抓板、剑麻猫抓柱、猫爬架等优质宠物用品，天然环保材料，10万+猫咪信赖之选。"
        keywords="猫抓板,猫抓柱,宠物用品,剑麻猫抓板,瓦楞纸猫抓板,猫爬架"
        canonical="/"
        ogImage="https://readdy.ai/api/search-image?query=cat%20scratching%20board%20natural%20sisal%20corrugated%20paper%20pet%20products%20brand%20logo%20minimalist%20warm%20background&width=1200&height=630&seq=og-home-001&orientation=landscape"
        jsonLd={HOME_JSONLD}
      />
      <Navbar />
      <HeroSection />
      <BrandSection />
      <FeaturedProducts />
      <FeaturesSection />
      <ReviewsSection />
      <CtaSection />
      <Footer />
    </div>
  );
}
